import { useEffect, useState } from "react";
import { helpHttp } from "../helper/helpHttp";
import { toast } from "react-toastify";
import { useNavigate, useOutletContext } from "react-router-dom";
import { useDispatch } from "react-redux";
import { changeLoading } from "../redux/slices/category";

const fleischmannV2 = {
  32: "Harina",
  33: "Levadura",
  34: "Sal Y Agua",
  35: "Ingredientes Enriquecedores",
  36: "Matemática Panadera",
};

const useTest = ({ modulo, getModuleDetail, isVentas = false }) => {
  const [reset, setReset] = useState(false);
  const [start, setStart] = useState(false);
  const [test, setTest] = useState(undefined);
  const [actualQuestion, setActualQuestion] = useState(undefined);
  const { post, get } = helpHttp();
  const initialState = { idEvaluacion: 1, respuestas: [] };
  const [response, setResponse] = useState(initialState);
  const [calificacion, setCalificacion] = useState(undefined);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [lastModule, setLastModule] = useState(null);
  const [courseId, setCourseId] = useState(null);
  const [moduleId, setModuleId] = useState(null);
  const dispatch = useDispatch();
  let evaluacionURL = "evaluaciones/registrarEvaluacion";

  if (isVentas) {
    evaluacionURL = "evaluaciones/registrarEvaluacionModulo";
  }

  if (modulo?.id && fleischmannV2[modulo.id]) {
    evaluacionURL =
      "evaluaciones/registrarEvaluacionModuloAprobadasEqualsConfiguradas";
  }

  useEffect(() => {
    // Onpopstate observa el evento de back button y beforeunload el de refresh y el de cerrar con la cruz
    window.onpopstate = handleSendIncompleteTest;
    window.addEventListener("beforeunload", handleSendIncompleteTest);
    return () => {
      window.removeEventListener("beforeunload", handleSendIncompleteTest);
    };
  }, [calificacion, start, response]);

  useEffect(() => {
    if (courseId) {
      dispatch(changeLoading(true));
      get(`modulos/getModulosByCategoria/${courseId}`)
        .then((data) => {
          const ids = data.datos.map(({ id }) => Number(id));
          setLastModule(Math.max(...ids));
        })
        .catch((error) => {
          toast.error("Ha ocurrido un error");
        })
        .finally(() => {
          dispatch(changeLoading(false));
        });
    }
  }, [courseId]);

  useEffect(() => {
    const url = window.location.href;
    const moduleId = url.split("/").at(-1);
    const courseId = url.split("/").at(-2);

    if (moduleId && courseId) {
      setCourseId(courseId);
      setModuleId(moduleId);
    }
  }, []);

  // Cuando se ingresa se cargan las respuestas que ya tenia el usuario y rellena las qeu faltan con 0
  const handleSendIncompleteTest = () => {
    const newResponse = { ...response };
    let lastResponse = newResponse?.respuestas?.length;
    if (!calificacion && start) {
      while (lastResponse < test?.length) {
        newResponse.respuestas.push({
          idPregunta: test[lastResponse].idPregunta,
          idRespuesta: "0",
        });
        lastResponse++;
      }
      post(evaluacionURL, {
        body: newResponse,
      });
    }
  };

  useEffect(() => {
    // Cuando las cantidad de respuestas es igual a la cantidad de preguntas se envian con el metodo Post
    response?.respuestas.length === test?.length &&
      post(evaluacionURL, {
        body: response,
      })
        .then((res) => {
          if (res.codigo === "400") {
            toast.error(res.mensaje);
            setOpen(false);
          } else {
            setCalificacion(res.datos);
            setResponse(initialState);
            setStart(false);
            if (res.datos.aprobado) {
              setTimeout(() => {
                toast.success("Has aprobado la evaluación");
                navigate(-1);
              }, 3000);
            }
          }
        })
        .catch(() => toast.error("Ha ocurrido un error"));
  }, [response]);

  useEffect(() => {
    // Cuando se inicia el test se cargan las preguntas por el momento la evaluacion 1
    if (modulo) {
      get(`evaluaciones/getEvaluacionByModulo/${modulo.id}`)
        .then((data) => {
          setTest(data.datos);
          setActualQuestion({
            number: 1,
            question: data.datos[0],
          });
        })
        .catch(() => toast.error("Ha ocurrido un error"));
    }
  }, [reset, modulo]);

  const handleResponse = (resp) => {
    setResponse({
      idEvaluacion: modulo.evaluacion,
      respuestas: [...response.respuestas, resp],
    });
    // if (actualQuestion?.number === test.length) {
    //   setStart(false)
    // }
    actualQuestion?.number < test.length &&
      setActualQuestion({
        number: actualQuestion.number + 1,
        question: test[actualQuestion.number],
      });
  };

  return {
    handleResponse,
    setReset,
    calificacion,
    actualQuestion,
    setCalificacion,
    test,
    start,
    setStart,
    open,
    setOpen,
  };
};

export default useTest;
